// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { successResponseSchema } from '@/api/schemas';

/**
 * Represents a request to delete a project.
 * This includes the key of the project to identify it and
 * a reason explaining why the project is being deleted.
 */
export interface DeleteProjectRequestParams {
  projectKey: string;
  reason: string;
}

/**
 * Deletes an existing project.
 *
 * @param props contains a list of properties
 */
export async function deleteProject(props: DeleteProjectRequestParams) {
  const path = `/v1/project/${props.projectKey}`;
  const response = await api.delete(path, {
    data: { reason: props.reason },
  });

  return parseResponse(successResponseSchema, response.data, {
    schemaName: 'DeleteProject',
    endpoint: path,
  });
}
